<template>
  <common-card>
    <v-row style="padding: 0px 30px 0px 30px">
      <v-col cols="12">
        <h1>Crear usuario</h1>
      </v-col>
    </v-row>
    <v-row style="padding: 0px 30px 0px 30px">
      <v-col cols="12" md="3">
        <v-text-field
          name="name"
          label="Nombre(s)"
          :rules="generalRules"
          v-model="usuario.nombre"
          outlined
          primary
          color="#00a7e4"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          name="apellidoPaterno"
          label="Apellido Paterno"
          :rules="generalRules"
          v-model="usuario.apellidoPaterno"
          outlined
          primary
          color="#00a7e4"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          name="apellidoMaterno"
          label="Apellido Materno"
          v-model="usuario.apellidoMaterno"
          outlined
          primary
          color="#00a7e4"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="usuario.sexo"
          :items="sexoList"
          item-text="sexo"
          item-value="id"
          label="Género"
          required
          :rules="generalRules"
          outlined
          primary
          color="#00a7e4"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="usuario.fechaNacimiento"
          label="Fecha de Nacimiento"
          placeholder="dd/mm/aaaa"
          outlined
          primary
          color="#00a7e4"
          type="date"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          item-text="estadoRepublica"
          item-value="id"
          v-model="usuario.nacimientoEstadoId"
          :items="estados"
          :rules="generalRules"
          placeholder="Seleccionar Estado de nacimiento"
          outlined
          primary
          color="#00a7e4"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          name="telefono"
          label="Teléfono"
          placeholder="##########"
          v-mask="'##########'"
          :rules="generalRules"
          v-model="usuario.telefono"
          outlined
          primary
          color="#00a7e4"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          label="Celular"
          placeholder="##########"
          v-mask="'##########'"
          v-model="usuario.celular"
          outlined
          primary
          color="#00a7e4"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          id="rfc"
          v-model="usuario.rfc"
          label="RFC"
          type="text"
          required
          placeholder="XAXX010101000"
          :rules="rfcRules"
          @input="onInputToUpper"
          outlined
          primary
          color="#00a7e4"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          autocomplete="new-password"
          label="Contraseña"
          v-model="usuario.password"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
          outlined
          primary
          color="#00a7e4"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="usuario.rol"
          :items="currentRoles"
          label="Rol"
          item-text="nombre"
          item-value="rol"
          :rules="generalRules"
          outlined
          primary
          color="#00a7e4"
        ></v-autocomplete>
      </v-col>
      <!-- //TODO CHANCE CAMBIAR ESTO https://github.com/Andxtorres/segurify-web-app/commit/350916e4fa70ffe93bd13f2fc8da2e7035141277 -->
      <v-col cols="12" md="3">
        <v-text-field
          v-model="usuario.fecha_ingreso"
          label="Fecha de Ingreso"
          placeholder="dd/mm/aaaa"
          v-mask="'##/##/####'"
          outlined
          primary
          color="#00a7e4"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="usuario.status"
          :items="status"
          label="Estatus"
          item-text="name"
          item-value="id"
          :rules="generalRules"
          outlined
          primary
          color="#00a7e4"
        ></v-autocomplete>
      </v-col>

      <v-col
        cols="12"
        md="3"
        v-if="
          usuario.rol == 'AGENTCC' ||
            usuario.rol == 'AGENTCCSPONSORS' ||
            usuario.rol == 'MESADECONTROL' ||
            usuario.rol == 'COBRANZACC' ||
            usuario.rol == 'RENOVACIONESCC' ||
            usuario.rol == 'MANAGERCC' ||
            usuario.rol == 'OPERADOR'
        "
      >
        <v-autocomplete
          label="Turno"
          v-model="usuario.turno"
          :items="['Matutino', 'Vespertino', 'Completo']"
          :rules="generalRules"
          placeholder="Seleccionar turno"
          outlined
          primary
          color="#00a7e4"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3" v-if="usuario.status == 'Baja'">
        <v-autocomplete
          v-model="usuario.motivoBaja"
          :items="motivoBajaItems"
          label="Motivo de Baja"
          :rules="generalRules"
          outlined
          primary
          color="#00a7e4"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="usuario.ramos"
          :items="ramoList"
          item-text="etiqueta"
          item-value="id"
          label="Ramo"
          multiple
          outlined
          primary
          color="#00a7e4"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip color="primary" v-if="index === 0">
              <span>{{ item.etiqueta }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption">
              (+{{ usuario.ramos.length - 1 }} más)
            </span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="usuario.canales"
          :items="canalList"
          label="Canal"
          item-text="etiqueta"
          item-value="id"
          multiple
          outlined
          primary
          color="#00a7e4"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip color="primary" v-if="index === 0">
              <span>{{ item.etiqueta }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption">
              (+{{ usuario.canales.length - 1 }} más)
            </span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="usuario.cuentas_correo"
          :items="cuentasCorreo"
          label="Cuentas de correo"
          item-value="id"
          item-text="cuenta"
          multiple
          outlined
          primary
          color="#00a7e4"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip color="primary" v-if="index === 0">
              <span>{{ item.cuenta }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption">
              (+{{ usuario.cuentas_correo.length - 1 }} más)
            </span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col
        cols="12"
        md="3"
        v-if="usuario.rol != 'AGENT' || usuario.rol == 'ADMIN'"
      >
        <v-text-field
          v-model="usuario.numero_colaborador"
          label="Número de colaborador"
          required
          :rules="generalRules"
          outlined
          primary
          color="#00a7e4"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3" v-if="showClaveValidador">
        <v-text-field
          v-model="usuario.extension"
          label="Extension validador"
          type="tel"
          :rules="numericRules"
          outlined
          primary
          color="#00a7e4"
          maxlength="10"
          counter
          @input="onValidadorInput"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="usuario.alianzas_inter"
          :items="alianzasList"
          item-text="nombre"
          item-value="id"
          label="Alianzas"
          multiple
          outlined
          primary
          color="#00a7e4"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip color="primary" v-if="index === 0">
              <span>{{ item.nombre }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption">
              (+{{ usuario.alianzas_inter.length - 1 }} más)
            </span>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row style="padding: 0px 30px 0px 30px">
      <v-col cols="12">
        <ListadoCorreos
          ref="listadoCorreos"
          :idAgente="idAgente"
          :canalesAgente="usuario.canales"
          :rolAgente="usuario.rol"
          @correoFavoritoModificado="correoFavoritoModificado"
        ></ListadoCorreos>
      </v-col>
      <v-col cols="12">
        <v-checkbox label="VIP" v-model="usuario.vip"></v-checkbox>
      </v-col>
    </v-row>
    <v-row style="padding: 0px 30px 0px 30px">
      <v-col cols="12">
        <v-col cols="12" style="text-align: end">
          <v-btn
            rounded
            dark
            outlined
            color="#00a7e4"
            style="margin-right: 11px;"
            @click="$router.back()"
          >
            <span> Cancelar </span>
          </v-btn>
          <v-btn
            @click="createUser()"
            class="common-botton mr-4"
            :disabled="validador"
            dark
          >
            Crear
          </v-btn>
        </v-col>
      </v-col>
    </v-row>
  </common-card>
</template>
<script>
import moment from "moment";
import RfcFacil from "rfc-facil";
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import ListadoCorreos from "@/components/listadoCorreos/ListadoCorreos.vue";
import { getCuentasCorreoListByParams } from "@/services/cuentasCorreo/cuentasCorreo.service.js";
import { getRamoList } from "@/services/ramo/ramo.service.js";
import { getCanalList } from "@/services/canal/canal.service.js";
import { getCampaniaLeads } from "@/services/campaings/campaing.service";
import { getLandingsList } from "@/services/landings/landings.service";
import { getRolesList, postCrearUsuario } from "@/services/user/user.service";
import { getAlianzasList } from "../../../../services/alianzas/alianzas.service";
const setListaDesplegable = require("@/helpers/diccionarios/permisosUsuarios.js");

export default {
  components: {
    ListadoCorreos,
    CommonCard,
  },
  data() {
    return {
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      roles: [],
      showPassword: false,
      showPassword2: false,
      usuario: {
        nombre: null,
        apellidoPaterno: null,
        apellidoMaterno: null,
        rfc: null,
        curp: null,
        password: null,
        sexo: null,
        fechaNacimiento: null,
        rol: null,
        nacimientoEstadoId: null,
        celular: null,
        telefono: null,
        correo: null,
        status: 1,
        motivoBaja: null,
        ramos: null,
        canales: null,
        landings: null,
        vip: false,
        turno: null,
        fecha_ingreso: null,
        cuentas_correo: [],
        alianzas_inter: [],
        extension: null,
        //claveValidador: null,
      },
      sexoList: [
        { id: 1, sexo: "Masculino" },
        { id: 2, sexo: "Femenino" },
      ],
      generalRules: [(v) => !!v || "Campo es necesario"],
      emailRules: [
        (v) => !!v || "E-mail es necesario",
        (v) =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail no es valido",
      ],
      numericRules: [
        (v) => !!v || "Campo es necesario",
        (v) => /^\d+$/.test(v) || "Sólo números",
      ],
      rfcRules: [
        (v) =>
          v.length === 10 ||
          v.length === 12 ||
          v.length === 13 ||
          "RFC debe tener 10, 12 o 13 caracteres",
        (v) => !!v || "Campo Requerido",
        (v) =>
          /^[A-Za-z\d]{10,13}$/.test(v) ||
          "RFC no es válido, asegúrate de tener la longitud correcta y utiliza caracteres alfanuméricos",
      ],
      curpRules: [
        (v) => !!v || "CURP es necesario",
        (v) =>
          /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/.test(
            v
          ) || "CURP no es valido recordar escribir en mayusculas",
      ],
      estados: [
        { id: 1, estadoRepublica: "Aguascalientes" },
        { id: 2, estadoRepublica: "Baja California" },
        { id: 3, estadoRepublica: "Baja California Sur" },
        { id: 4, estadoRepublica: "Campeche" },
        { id: 5, estadoRepublica: "Coahuila de Zaragoza" },
        { id: 6, estadoRepublica: "Colima" },
        { id: 7, estadoRepublica: "Chiapas" },
        { id: 8, estadoRepublica: "Chihuahua" },
        { id: 9, estadoRepublica: "Ciudad de México" },
        { id: 10, estadoRepublica: "Durango" },
        { id: 11, estadoRepublica: "Guanajuato" },
        { id: 12, estadoRepublica: "Guerrero" },
        { id: 13, estadoRepublica: "Hidalgo" },
        { id: 14, estadoRepublica: "Jalisco" },
        { id: 15, estadoRepublica: "Estado de México" },
        { id: 16, estadoRepublica: "Michoacán de Ocampo" },
        { id: 17, estadoRepublica: "Morelos" },
        { id: 18, estadoRepublica: "Nayarit" },
        { id: 19, estadoRepublica: "Nuevo León" },
        { id: 20, estadoRepublica: "Oaxaca" },
        { id: 21, estadoRepublica: "Puebla" },
        { id: 22, estadoRepublica: "Querétaro" },
        { id: 23, estadoRepublica: "Quintana Roo" },
        { id: 24, estadoRepublica: "San Luis Potosí" },
        { id: 25, estadoRepublica: "Sinaloa" },
        { id: 26, estadoRepublica: "Sonora" },
        { id: 27, estadoRepublica: "Tabasco" },
        { id: 28, estadoRepublica: "Tamaulipas" },
        { id: 29, estadoRepublica: "Tlaxcala" },
        { id: 30, estadoRepublica: "Veracruz" },
        { id: 31, estadoRepublica: "Yucatán" },
        { id: 32, estadoRepublica: "Zacatecas" },
        { id: 33, estadoRepublica: "Desconocio" },
      ],
      canalList: [],
      ramoList: [],
      campaniaList: [],
      status: [
        { id: 0, name: "Nuevo" },
        { id: 1, name: "Activo" },
        { id: 2, name: "Inactivo" },
        { id: -1, name: "Baja" },
      ],
      motivoBajaItems: [
        "Encontró trabajo",
        "Falta de pago de comisiones",
        "Falta de producción",
        "Falta de seguimiento del área comercial",
        "Falta de seguimiento del área de operaciones",
        "Inconformidad con el proceso de capacitación",
        "Inconformidad con la oferta de valor",
        "Exceso de faltas",
        "Ingreso a escuela",
        "Temas de salud",
        "Otro",
      ],
      idAgente: null,
      cuentasCorreo: [],
      alianzasList: [],
    };
  },

  watch: {
    "usuario.fechaNacimiento"() {
      this.actualizarRfc();
    },
    "usuario.nombre"() {
      this.actualizarRfc();
    },
    "usuario.apellidoPaterno"() {
      this.actualizarRfc();
    },
    "usuario.apellidoMaterno"() {
      this.actualizarRfc();
    },
    "usuario.rol"() {
      if (!this.showClaveValidador) this.usuario.extension = null;
    },
  },

  computed: {
    validador() {
      let valdadorSum = 0;
      this.usuario.password
        ? this.usuario.password.length > 0
          ? (valdadorSum = valdadorSum + 1)
          : ""
        : "";
      this.usuario.nombre
        ? this.usuario.nombre.length > 0
          ? (valdadorSum = valdadorSum + 1)
          : ""
        : "";
      this.usuario.apellidoPaterno
        ? this.usuario.apellidoPaterno.length > 0
          ? (valdadorSum = valdadorSum + 1)
          : ""
        : "";
      this.usuario.telefono
        ? this.usuario.telefono.length > 9
          ? (valdadorSum = valdadorSum + 1)
          : ""
        : "";
      this.usuario.correo
        ? this.usuario.correo.length > 0
          ? (valdadorSum = valdadorSum + 1)
          : ""
        : "";
      this.usuario.nacimientoEstadoId
        ? this.usuario.nacimientoEstadoId.length > 0
          ? (valdadorSum = valdadorSum + 1)
          : ""
        : "";
      this.usuario.rfc
        ? this.usuario.rfc.length > 0
          ? (valdadorSum = valdadorSum + 1)
          : ""
        : "";
      if (valdadorSum == 6) {
        return false;
      } else {
        return true;
      }
    },
    currentRoles() { // TODO PROBABLEMENTE SE TIENE QUE CAMBIAR https://github.com/Andxtorres/segurify-web-app/commit/d06051fdaf7b4f08f20c0184ae96405ea741b0a5
      let roles = setListaDesplegable(this.rol);
      let resultado = [];
      if (roles === true) {
        return this.roles;
      }
      roles.map((rol) => {
        resultado = resultado.concat(this.roles.filter((e) => e.rol == rol));
      });
      console.log({ resultado });
      return resultado;
    },
  },

  methods: {
    correoFavoritoModificado(v) {
      this.usuario.correo = v;
    },
    showClaveValidador() {
      const sel = this.roles.find((r) => r.id == this.usuario.rol);
      const nombre = sel && sel.nombre ? sel.nombre.trim().toUpperCase() : "";
      return (
        this.usuario.rol === "VALIDADORCC" ||
        this.usuario.rol == "MANAGERCC" ||
        nombre === "ECI - VALIDADOR VENTA"
      );
    },
    actualizarRfc() {
      if (
        !this.usuario.nombre ||
        !this.usuario.apellidoPaterno ||
        !this.usuario.apellidoMaterno ||
        !this.usuario.fechaNacimiento
      )
        return;
      const arregloNacimiento = moment(this.usuario.fechaNacimiento)
        .format("DD/MM/YYYY")
        .split("/")
        .map((e) => Number(e));
      if (arregloNacimiento.length < 3) return;
      const rfc = RfcFacil.forNaturalPerson({
        name: this.usuario.nombre,
        firstLastName: this.usuario.apellidoPaterno,
        secondLastName: this.usuario.apellidoMaterno,
        day: arregloNacimiento[0],
        month: arregloNacimiento[1],
        year: arregloNacimiento[2],
      });
      this.usuario.rfc = rfc;
      this.usuario.password = this.usuario.rfc;
    },
    async createUser() {
      let request = {
        ...this.usuario,
        fecha_ingreso: this.usuario.fecha_ingreso
          ? moment(this.usuario.fecha_ingreso, "DD/MM/YYYY").format(
              "YYYY-MM-DD HH:mm:ss"
            )
          : null,
          extension: Number(this.usuario.extension || 0),
      };
      let response = await postCrearUsuario(request);
      this.idAgente = response.id;
      await this.$refs.listadoCorreos.actualizarCorreos();
      this.$toast.success("Usuario creado con exito");
      this.$router.push("/usuarios");
    },
    onInputToUpper() {
      this.usuario.rfc = this.usuario.rfc.toUpperCase();
    },
    onValidadorInput(val) {
      this.usuario.extension = (val || "").toString().replace(/\D+/g, "");
    },
    async getCuentasCorreoListByParams() {
      var body = {
        ...{
          pagina: 1,
          elementosPagina: 100,
        },
      };
      let response = await getCuentasCorreoListByParams(body);
      this.cuentasCorreo = response.cuentas ?? [];
    },
    async getCanalList() {
      this.canalList = await getCanalList();
    },
    async getRamosList() {
      this.ramoList = await getRamoList();
      console.log(this.ramoList);
    },
    async getCampaniaLeads() {
      this.campaniaList = await getCampaniaLeads();
    },
    async getLandingsList() {
      this.landings = await getLandingsList();
    },
    async getRolesList() {
      this.roles = await getRolesList();
    },
    async getAlianzasList() {
      this.List = await getAlianzasList();
      this.alianzasList = this.List.data;
    },
  },
  mounted() {
    this.getCuentasCorreoListByParams();
    this.getCanalList();
    this.getRamosList();
    this.getCampaniaLeads();
    this.getLandingsList();
    this.getRolesList();
    this.getAlianzasList();
  },
};
</script>

<style>
.mayusculas {
  text-transform: uppercase;
}
</style>
